import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";

// Save a design as a template (design) or edit an existing template's name/category (template)
export const TemplateMetaDialog = ({ design, template, onClose, onSaved }) => {
  const src = template || design;
  const [form, setForm] = useState({ name: "", category: "" });
  const [cats, setCats] = useState([]);
  useEffect(() => {
    if (!src) return;
    setForm({ name: src.name || "", category: template?.category || "" });
    api.get("/design-templates").then((r) => setCats([...new Set(r.data.map((t) => t.category).filter(Boolean))]));
  }, [src, template]);

  const submit = async (e) => {
    e.preventDefault();
    try {
      const body = { name: form.name.trim(), category: form.category.trim() };
      const r = template
        ? await api.put(`/design-templates/${template.id}`, body)
        : await api.post("/design-templates", { ...body, shapes: design.shapes, scale: design.scale, image: design.image });
      toast.success(template ? "Template updated" : `Saved "${body.name}" as a template`);
      onSaved?.(r.data);
      onClose();
    } catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <Dialog open={!!src} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="template-meta-dialog">
        <DialogHeader><DialogTitle className="font-display text-2xl uppercase">{template ? "Edit template" : "Save as template"}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <div><Label>Template name</Label><Input data-testid="template-name-input" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></div>
          <div>
            <Label>Category</Label>
            <Input data-testid="template-category-input" list="tpl-cats" placeholder="e.g. Grease traps, Hood ducts" value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} />
            <datalist id="tpl-cats">{cats.map((c) => <option key={c} value={c} />)}</datalist>
            {!!cats.length && (
              <div className="mt-2 flex flex-wrap gap-1">
                {cats.map((c) => <button type="button" key={c} data-testid={`template-category-chip-${c}`} onClick={() => setForm({ ...form, category: c })} className={`rounded-full px-2.5 py-0.5 text-xs ring-1 ${form.category === c ? "bg-red-600 text-white ring-red-600" : "ring-zinc-200 hover:ring-zinc-400"}`}>{c}</button>)}
              </div>
            )}
          </div>
          <DialogFooter><Button data-testid="template-meta-save" type="submit" className="bg-red-600 hover:bg-red-700">Save template</Button></DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
